/**
  * create 2020-06-21
  *  author huangxu
 */
<template>
  <div class="python-data">
    <div class="banner" v-lazy:background-image="{ src:require('../pythonImg/bj.png'), loading: require('../pythonImg/bj1.png') }">
      <div class="divContsBg"></div>
      <div class="conts">
        <ul>
          <slot name="navList"></slot>
        </ul>
        <div class="texts">
          <h1>{{backGroundCom.title}}</h1>
          <p>{{backGroundCom.title1}}</p>
          <ul class="imglist" style="width: 50%;">
            <li v-for="(item, index) in backGroundCom.projectList" :key="item.id">
              <img :src="imgList[index]" alt="" />
              <div>
                <span style="color: #fff;margin-top: 20px;display: block;font-size: 18px;">{{item.realList}}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    backGroundCom: {
      readonly: true,
      require: true,
      default: () => {}
    }
  },
  data () {
    return {
      imgList: [
        require("../pythonImg/web2x_icon_dachangji2.png"),
        require("../pythonImg/web2x_icon_dachangji24.png"),
        require("../pythonImg/web2x_icon_dachangji23.png"),
        require("../pythonImg/web2x_icon_dachangji22.png")
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .python-data {
    padding: 0;
    margin: 0;
    background: #fff;
    min-width: 1200px;
    .banner {
      width: 100%;
      height: 510px;
      overflow: hidden;
      position: relative;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      .divContsBg {
        // background-color: black;
        position: absolute;
        width: 100%;
        height: 81px;
        top: 0;
        // opacity: 0.11;
      }
      .conts {
        width: 1200px;
        margin: 0 auto;
        position: relative;
        ul {
          display: flex;
          justify-content: space-around;
          // margin-top: 24px;
          .title-nav {
            height: 32px;
            border-radius: 20px;
            background-color: white;
            cursor: pointer;
            &:hover {
              color: #1286FF;
            }
            a {
              border-radius: 20px;
              line-height: 32px;
              width: 100%;
              padding: 7px 35px;
              box-sizing: border-box;
            }
          }
          .active {
            background: #1286FF;
            color: #f9f9f9 !important;
            a {
              color: #f9f9f9 !important;
            }
          }
        }
      }
      .texts {
        padding-top: 40px;
        h1 {
          font-size: 45px;
          font-family: "PingFangSC", "PingFangSC-Regular";
          text-align: left;
          color: #ffffff;
          font-weight: 400;
          line-height: 60px;
          letter-spacing: 3px;
          height: 69px;
          color: rgba(255, 255, 255, 1);
          margin-top: 80px;
          span {
            font-size: 60px;
          }
        }
        p {
          height: 71px;
          font-size: 24px;
          font-weight: 400;
          opacity: .8;
          color: #fff;
          line-height: 40px;
          margin-top: 10px;
          overflow: hidden;
          font-family: "PingFangSC", "PingFangSC-Semibold";
        }
        ul {
          margin-left: -40px;
          li {
            text-align: center;
            img {
              width: 40px;
              height: 40px;
              vertical-align: middle;
              display: inline-block;
              text-align: center;
              margin: 0 auto;
            }
            span {
              font-family:  "PingFangSC", "PingFangSC-Semibold";
            }
          }
        }
      }
    }
    
  }
</style>